import { Injectable } from '@angular/core';
import { Confirmation } from 'primeng';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() { }
  //#region  Global Alert Message
  private messageSource = new BehaviorSubject(null);
  currentMessage = this.messageSource.asObservable();
  showAlertMessage(message: string) {
    this.messageSource.next(message)
  }
  //#endregion  Global Alert Message

//#region  Error Page Message
  private erroPageMessage = new BehaviorSubject(null);
  currentErrorPageMessage = this.erroPageMessage.asObservable();
  setErrorPageMessage(message: string) {
    this.messageSource.next(message)
  }
//#region  Error Page Message
  
//#region Confirm Dialog Service
private subject = new Subject<any>();  
confirmThis(message: string, accept: () => void, reject: () => void=null) { 
  this.setConfirmation(message, accept, reject);  
}  
setConfirmation(message: string, accept: () => void, reject: () => void) {  
  let that = this;  
  this.subject.next({  
      type: "confirm",  
      text: message,  
      accept:  
          function () {  
              that.subject.next(); //this will close the modal  
              accept();  
          },  
      reject: function () {  
          that.subject.next();  
         if(reject){ reject();}  
      }  
  });  

}  

  getMessage(): Observable<any> {  
    return this.subject.asObservable();  
  }  
//#endregion 
//#region Generic Confirm Dialog Service
private genericConfirmSubject = new BehaviorSubject<any>(null);  
genericConfirm(message: Confirmation, accept: () => void, reject: () => void=null) { 
  this.emitGenericConfirmation(message, accept, reject);  
}  
emitGenericConfirmation(message: Confirmation, accept: () => void, reject: () => void) {  
  let currentSession = this;  
  this.genericConfirmSubject.next({  
       genericMessage:message,  
      accept:  
          function () {  
            currentSession.genericConfirmSubject.next(null); //this will close the modal  
              accept();  
          },  
      reject: function () {  
        currentSession.genericConfirmSubject.next(null);  
         if(reject){ reject();}  
      }  
  });  

}
getGenericConfirmationMessage(): Observable<any>
{  
  return this.genericConfirmSubject.asObservable();  
}    
//#endregion
closeAllDialog()
{
  this.genericConfirmSubject.next(null);
  this.erroPageMessage.next(null);
  this.messageSource.next(null);

} 
}
